// extracted by mini-css-extract-plugin
export default {"bingoInfo":"BingoInfo_bingoInfo__0kzPX","title":"BingoInfo_title__RkzF-"};